import { useForm } from "@/hooks/common/use-form";
import { joinNames } from "@/utils";
import { clsx } from "clsx";
import { Icon } from "../../Icon";
import { InputValue } from "../../inputs";

export interface TableSearchBarProps {
  onChange: (value: string) => void;
  fields: string[];
}

export const TableSearchBar = ({ onChange, fields }: TableSearchBarProps) => {
  const { control } = useForm({
    handleSubmit: async () => null,
    fields: { seartchTerm: { validation: "none" } },
  });

  const searchTerm = control.watch("seartchTerm");

  const handleSearchIconClick = () => {
    if (searchTerm) {
      onChange(searchTerm);
    }
  };

  return (
    <InputValue
      control={control}
      field="seartchTerm"
      placeholder={`Buscar por ${joinNames(fields)}`}
      className="w-full md:w-[20rem]"
      trailing={
        <Icon
          name="Search"
          className={clsx("text-primary hover:opacity-50 duration-300 transition-opacity", {
            "pointer-events-none opacity-50": !searchTerm,
          })}
          onClick={searchTerm ? handleSearchIconClick : undefined}
        />
      }
    />
  );
};
